import { SVGProps, Ref, forwardRef } from 'react';

export const DropsOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.663 0c.015.014 3.334 3.167 3.334 6.667l-.005.17A3.334 3.334 0 0 1 11.663 10l-.023-.001q.026.333.027.668l-.007.274a5.334 5.334 0 0 1-10.653 0L1 10.667C1 5.073 6.298.033 6.333 0c0 0 1.438 1.364 2.821 3.462.981-2.006 2.49-3.444 2.51-3.462m-5.33 2.054a22 22 0 0 0-1.508 1.96C3.552 5.893 2.4 8.276 2.4 10.668a3.933 3.933 0 0 0 7.867 0 8 8 0 0 0-.069-1.009 3.33 3.33 0 0 1-1.864-2.82l-.004-.171c0-.528.076-1.047.204-1.55a19 19 0 0 0-.692-1.102 22 22 0 0 0-1.509-1.961m5.33.055c-.163.209-.336.442-.508.695-.773 1.14-1.425 2.524-1.425 3.863a1.933 1.933 0 0 0 3.867 0c0-1.34-.652-2.723-1.425-3.863a13 13 0 0 0-.509-.695"
            fill="currentColor"
        />
    </svg>
));
DropsOutlinedSize16Glyph.displayName = 'DropsOutlinedSize16Glyph';
